/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Typography, Box, Grid } from '@mui/material';
import { CustomTextField } from '../Forms/CustomTextField';

export const FormContainer = (props) => {
  return (
    <Box sx={{ mx: 3, mb: 4 }}>
      <Typography variant="h6">{props.title}</Typography>
      <Grid container>
        <Grid item xs={12}>
          <CustomTextField
            required={props.longRequired}
            label={props.longTitle}
            onChange={props.onChangeLong}
            disabled={props.disabled}
            defaultValue={props.longDefault}
            type={props.longType}
            error={props.longError}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sx={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <Grid item xs={6} sx={{ mr: 1.4 }}>
            <CustomTextField
              required={props.leftRequired}
              label={props.leftTitle}
              onChange={props.onChangeLeft}
              disabled={props.disabled}
              defaultValue={props.leftDefault}
              type={props.leftType}
              error={props.leftError}
            />
          </Grid>
          <Grid item xs={6} sx={{ ml: 1.4 }}>
            <CustomTextField
              required={props.rightRequired}
              label={props.rightTitle}
              onChange={props.onChangeRight}
              disabled={props.disabled}
              defaultValue={props.rightDefault}
              type={props.rightType}
              error={props.rightError}
              errorMsg={props.rightErrorMsg}
            />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
